// names goes to the mapping are transformed:
// 1. to lowercase
// 2. _ are replaced with space
// 3. trimmed
// 4. VOY_ and LD_ prefixes are removed
// 5. (LD) suffix is removed
const NAMES_MAPPING = {
  created: 'created at',
  'recipient id': 'user id',
  'email open': 'email opened',
  'email introduce to sale': 'hot lead trigger',
  'email click': 'email clicked',
  'source (old)': 'source old',
  'email send': 'email sent',
  suppressed: 'suppression list',
  'sms send': 'sms sent',
  'estimated household income': 'est. household income',
  'auto body type': 'auto type',
  'lgbt supporters/donors': 'LGBTQ+ Donor/Supporter',
  credrate: 'credit rating',
  singparent: 'single parent',
  nascar: 'NASCAR',
  zip: 'ZIP',
  'childrens products': 'children products',
  'eu limits detected at': 'EU limits detected at',
  'ctm ad id': 'CTM ad id',
  'ctm ad name': 'CTM ad name',
  'ctm ad set name': 'CTM ad set name',
  'ctm campaign name': 'CTM campaign name',
  'personal emails validation status': 'Personal Email Validation Status',
};

const systemVariables = ['gender'];

export const formatVariableNames = (name: string) => {
  const friendlyName = `${NAMES_MAPPING[name.toLowerCase()] || name}${
    systemVariables[name.toLocaleLowerCase()] ? ' (system)' : ''
  }`;
  return friendlyName;
};

export const normalizeVariableName = (variableName: string) => {
  const prefixes = ['VOY_', 'LD_'];
  const suffix = '(LD)';
  let value = variableName;
  value = prefixes.reduce(
    (acc, prefix) => (acc.startsWith(prefix) ? acc.slice(prefix.length) : acc),
    variableName,
  );

  if (value.endsWith(suffix)) {
    value = value.slice(0, -suffix.length);
  }
  const normalizedName = value.replace(/_/g, ' ')?.toLowerCase()?.trim();

  return formatVariableNames(normalizedName);
};

export const hiddenVariables = [
  'sessions count',
  'last active',
  'email reply',
  'wday',
  'suppression_list_include',
  'suppression list include',
  'email reply',
  'ld perm individual id',
  'fb messenger user id',
];
